import { Typography } from '@material-ui/core';
import React from 'react';
import { APP_VERSION } from '../../version';
import menuStyles from './menu.less';

export function MenuVersion() {
  return (
    <Typography variant="subtitle2" className={menuStyles.version}>
      Version {APP_VERSION}
    </Typography>
  );
}
